// Palette commune : teintes Tailwind de niveau 700. En fond sous du texte blanc
// comme en texte sur fond blanc, elles restent au-dessus de 4,5:1, alors que
// les teintes 500 tombent sous ce seuil (jusqu'a 1,91:1 pour yellow).

// Avatar de la barre laterale, choisi par un hash du nom.
export const AVATAR_BG_CLASSES = [
  'bg-red-700',
  'bg-orange-700',
  'bg-amber-700',
  'bg-yellow-700',
  'bg-lime-700',
  'bg-green-700',
  'bg-emerald-700',
  'bg-teal-700',
  'bg-cyan-700',
  'bg-sky-700',
  'bg-blue-700',
  'bg-indigo-700',
  'bg-violet-700',
  'bg-purple-700',
  'bg-fuchsia-700',
  'bg-pink-700',
]

// Programmes : 8 teintes bien distinctes. La cle est stockee en base
// (colonne program.color, attribuee par l'API). Le texte s'affiche aussi sur
// le fond gris d'une conversation ouverte (bg-accent) : l'ambre 700 y tombe a
// 4,35:1, d'ou le 800 (6,13:1). Couvert par e2e/a11y-program-palette.spec.ts.
export const PROGRAM_TEXT_CLASSES = {
  blue: 'text-blue-700',
  emerald: 'text-emerald-700',
  violet: 'text-violet-700',
  rose: 'text-rose-700',
  amber: 'text-amber-800',
  cyan: 'text-cyan-700',
  fuchsia: 'text-fuchsia-700',
  orange: 'text-orange-700',
} as const

export type ProgramColorType = keyof typeof PROGRAM_TEXT_CLASSES

const PROGRAM_COLOR_KEYS = Object.keys(PROGRAM_TEXT_CLASSES) as ProgramColorType[]

// Classe de texte d'un programme ; si la couleur manque ou est inconnue,
// on en deduit une de l'id pour ne jamais afficher de surtitre sans couleur.
export function getProgramTextClass(program: { id: string; color?: string | null }): string {
  if (program.color && program.color in PROGRAM_TEXT_CLASSES) {
    return PROGRAM_TEXT_CLASSES[program.color as ProgramColorType]
  }
  let hash = 0
  for (const char of program.id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0
  return PROGRAM_TEXT_CLASSES[PROGRAM_COLOR_KEYS[hash % PROGRAM_COLOR_KEYS.length]]
}
